@if (!!notification) {
    <ms-epcot-notification [notificationType]="'warning'" [showCloseButton]="true" (closeButtonClick)="onCloseButtonClick()">
        <section class="pc-txt" message>{{ notification }}</section>
    </ms-epcot-notification>
}
